import BaseInputContext from './context';

export const useBaseInput = BaseInputContext.hook;
